import React from 'react'



// STYLE //
import './stylesHeader.scss'

function Header(props) {
  return (
    <div className='header'>
      <h1 className='header_text'> KESKONMATE </h1>
      <ul className='header_list'>
            <li className='header_list_item'> 
              <a target='blank' className='header_list_item_link' href={"https://twitter.com/AntoineLrtDev"}>Twitter</a>
            </li>
             <li className='header_list_item'> 
              <a target='blank' className='header_list_item_link' href={"https://github.com/Antoine-Lrt"}>GitHub</a>
            </li>
            <li className='header_list_item'> 
              <a target='blank' className='header_list_item_link' href={"https://antoine-laurent-portfolio.netlify.app/"}>Portfolio</a>
            </li>       
        </ul>
    </div>
  )
}

Header.propTypes = {}

export default Header
